import Api from "../Api";
import {useEffect, useState} from "react";
import {Form, Radio, RadioChangeEvent, Select, Space, Spin} from "antd";
import {useUpload} from "../../context/Upload";
import {useAuth} from "../../context/Auth";

interface SelectOptions {
    label: string;
    value: string
}

const groupAdaptor = (collection: any[]) => {
    return collection.map((item) => ({
        value: item.GroupName,
        label: item.GroupName
    }))
}

const DestinationStep = () => {
    const {setStatus, status, options, setOptions} = useUpload();
    const {user} = useAuth();

    const [manufacturerFolder, setManufacturerFolder] = useState<SelectOptions[]>();
    const [loading, setLoading] = useState(true);

    const onDataTypeChange = (e: RadioChangeEvent) => {
        setStatus({
            ...status,
            dataType: true,
        })
        setOptions({
            ...options,
            selectedDataType: e.target.value
        })
    }

    const onDestinationChange = (value: string | null) => {
        setStatus({
            ...status,
            destination: true,
        })
        setOptions({
            ...options,
            selectedDestination: value!
        })
    }

    const fetchDestination = async () => await Api.management.getDestinationFolder();

    useEffect(() => {
        (async () => {
            setLoading(false)
            const res = await fetchDestination();
            setManufacturerFolder(groupAdaptor(res.data.Groups))
            console.log('res', res);
        })()
    }, [])

    return (
        <>
            <Form.Item>
                <h3>Select your data type</h3>
                <Radio.Group defaultValue={options && options.selectedDataType}
                             onChange={(val) => onDataTypeChange(val)}>
                    <Space direction="vertical">
                        <Radio value={"oem-vehicle-specific-data"}>Vehicle Sale Individualized Data</Radio>
                        <Radio value={"oem-summary-data"}>Vehicle Sale Grouped Data</Radio>
                        {/* <Radio disabled={!user?.["cognito:groups"].includes("Admins")} value={"credit-trading-data"}>Credit Trading Data</Radio> */}
                    </Space>
                </Radio.Group>
            </Form.Item>
            <Form.Item>
                <h3>Select your destination folder</h3>
                <Select style={{width: '100% !important'}} showSearch
                        defaultValue={options && options.selectedDestination}
                        onChange={(val) => onDestinationChange(val)}
                        loading={loading}
                        options={manufacturerFolder}
                        placeholder={"Destination folder"}
                        notFoundContent={manufacturerFolder ? <Spin size="small"/> : null}
                        filterOption={(input, option) => (option!.label as unknown as string).includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA!.label as unknown as string)
                                .toLowerCase()
                                .localeCompare((optionB!.value as unknown as string).toLowerCase())
                        }/>
            </Form.Item>
        </>
    )
}

export default DestinationStep;
